import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import GoogleCloudRegistryConfigListing from './GoogleCloudRegistryConfigListing'
import GoogleCloudRegistryCredentialsForm from './GoogleCloudRegistryCredentialsForm'

export default function GoogleCloudRegistryPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={GoogleCloudRegistryCredentialsForm}
            PullConfigListingView={GoogleCloudRegistryConfigListing}
        />
    )
}
